export default __webpack_public_path__ + "static/media/sidebar-icon3.7ea8d166.svg";